module.exports = __webpack_public_path__ + "img/logo.716e2a0d.jpg";